import { Action, createReducer, on } from '@ngrx/store';
import {
  getConnectedCompanyIntegrationsAction,
  getConnectedCompanyIntegrationsFailureAction,
  getConnectedCompanyIntegrationsSuccessAction,
} from './get-connected-company-integrations.actions';
import { GetConnectedCompanyIntegrationsState } from './get-connected-company-integrations.types';

const initialState: GetConnectedCompanyIntegrationsState = {
  loading: false,
  loaded: false,
  received: false,
};

const getConnectedCompanyIntegrationsReducer = createReducer(
  initialState,
  on(getConnectedCompanyIntegrationsAction, state => ({
    ...state,
    loading: true,
    loaded: false,
    received: false,
    data: undefined,
    error: undefined,
  })),
  on(getConnectedCompanyIntegrationsSuccessAction, (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    received: true,
    data: action.data,
    error: undefined,
  })),
  on(getConnectedCompanyIntegrationsFailureAction, (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    received: true,
    error: action.error,
  })),
);

export const reducer = (
  state: GetConnectedCompanyIntegrationsState,
  action: Action,
) => getConnectedCompanyIntegrationsReducer(state, action);
